import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import NavBarMarket from "../components/NavBar/NavBar";
import { get } from "lodash";
import { CONTENTFUL_ENTRIES } from "../constants/ContentConstats";
import { NavSectionConfig, NavLink } from "../components/NavBar/types/navbar";
import { CountriesType } from "../components/NavBar/components/CountriesSelect/CountriesSelect";

const RootLayout = () => {
  const { country } = useParams<{ country: string }>();
  const [navbarConfigData, setNavbarConfigData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNavbar = async () => {
      if (!country) return;

      const entries = CONTENTFUL_ENTRIES[country as keyof typeof CONTENTFUL_ENTRIES];
      const navbarConfigEntryId = entries?.navbarConfig;

      try {
        if (navbarConfigEntryId) {
          const res = await fetch(`https://cdn.contentful.com/spaces/2s65zqhp8au5/entries/${navbarConfigEntryId}`, {
            headers: {
              Authorization: "Bearer y0IYxPnHITMQAbl3NERyBLUdvMzb8p3ON1tLtlDRna0",
            },
          });

          if (res.ok) {
            const data = await res.json();
            setNavbarConfigData(data.fields);
          }
        }
      } catch (error) {
        console.error("Error cargando navbar:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNavbar();
  }, [country]);

  const navbarConfig: NavSectionConfig[] = get(navbarConfigData, "sections", []);
  const countries: CountriesType[] = get(navbarConfigData, "countries", []);
  const iconLinks: NavLink[] = get(navbarConfigData, "iconLinks", []);
  const transparentRoutes: string[] = get(navbarConfigData, "transparentRoutes", []);

  return (
    <>
      {!loading && (
        <NavBarMarket
          navbarConfig={navbarConfig}
          countries={countries}
          iconLinks={iconLinks}
          transparentRoutes={transparentRoutes}
        />
      )}

      <Outlet />
    </>
  );
};

export default RootLayout;
